module.exports = __webpack_public_path__ + "img/_54A6697.fb30a5ea.jpg";